import languageUtils from '$common/utils/language';

export default function getTextMixin(params) {
  const { texts } = params

  return {
    provide() {
      return {
        getText: this.getText
      }
    },
    computed: {
      lang() {
        const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
        return navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';
      }
    },
  
    methods: {
      getText(key, params) {
        let val = texts[this.lang][key] || key
        if (params && typeof params === 'object') {
          Object.keys(params).forEach(key => {
            const reg = new RegExp('{' + key + '}')
            val = val.replace(reg, params[key])
          })
        }
        return val
        // return texts[this.lang][key] || key
      }
    }
  }
}